export default () => {
  const isMobile = ref(false)

  const onMediaChange = (media) => {
    //Don't execute if running server-side rendering.
    if (!process.server) {
      //console.log(media.matches, 'media')
      isMobile.value = media.matches
    }
  }

  //Don't execute if running server-side rendering.
  if (!process.server) {
    const media = window.matchMedia('only screen and (max-width: 767px)')
    media.onchange = onMediaChange
    onMediaChange(media)
  }

  /**
   * This function provides mobile tools. Currently, the only tool is the isMobile attribute which determines if
   * the device is in a 'mobile' format.  The code uses the matchMedia functionality which provides the advantage of
   * working in a desktop browser as well if in a mobile format making it easier to build and debug mobile format code.
   */
  return { isMobile }
}